import React, { useCallback } from 'react'
import AddIcon from '../../../../../Icons/addIcon'
import styles from '../../historySection.module.css'
import { IEscalationComments } from '../../../../../../Models/applicationModels';
import { CommentItemType } from '../../../../createEscalation.models';

interface HistoryHeaderItemProps {
    canAddComment: boolean;
    setCommentItems: React.Dispatch<React.SetStateAction<IEscalationComments[]>>;
    applicationEscalationUid: string | null;
    opportunityUid: string;
}

export const HistoryHeaderItem = ({ canAddComment, setCommentItems, applicationEscalationUid, opportunityUid }: HistoryHeaderItemProps) => {
    const handleAddComment = useCallback(() => {
        
        setCommentItems((prev) => [{
            commentType: CommentItemType.DRAFT_COMMENT,
            comment: "",
            escalationStatus: null,
            files: null,
            commentUid: "",
            applicationEscalationUid: applicationEscalationUid ?? "",
            createdBy: null,
            createdOn: null,
            isCommentEmailSend: false,
        }, ...prev]);    
    }, [setCommentItems]);


    return (
        <div className={styles.historySectionHeader}>
            <div className={styles.historySectionHeaderTitle}>
                History
            </div>

            {canAddComment && (
                <button type="button" className={styles.historySectionHeaderActions} onClick={handleAddComment} >
                    <AddIcon />
                    Comment
                </button>
            )}
        </div>
    )
}
